import React from "react";
import { CustomCard } from "../../CustomCard";
import { Box } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";

// styles
import useStyle from "./styles";

const DocumentsPropertyCardSkeleton = () => {
  const styles = useStyle();
  return (
    <CustomCard
      boxShadow="xs"
      borderRadius="xl"
      borderColor="secondary"
      classes={styles.cardWrapper}
    >
      <Box className={styles.cardContainer}>
        <Box className={styles.headingContainer}>
          <Skeleton variant="rect" width={98} height={117} />
          <Box className={styles.container_MoreIcon}>
            <Skeleton
              className={styles.dot}
              variant="circle"
              width={4}
              height={4}
              animation="wave"
            />
            <Skeleton
              className={styles.dot}
              variant="circle"
              width={4}
              height={4}
              animation="wave"
            />
            <Skeleton
              className={styles.dot}
              variant="circle"
              width={4}
              height={4}
              animation="wave"
            />
          </Box>
        </Box>
        <Box className={styles.contentContainer}>
          <Box className={styles.titleWrapper}>
            <Skeleton variant="text" width={98} height={25} />
            <Box className={styles.documentNameWrapper}>
              <Skeleton variant="text" width={20} height={30} />
              <Skeleton variant="text" width={100} height={30} />
            </Box>
          </Box>
          <Box className={styles.footerContainer}>
            <Skeleton variant="text" width={200} height={35} />
          </Box>
        </Box>
      </Box>
    </CustomCard>
  );
};

export default DocumentsPropertyCardSkeleton;
